export const environment = {
  production: true,
  buildId: '3973954622524061',
  configFile: 'config.json',
};
